import React, { useState, useEffect } from "react";

import { Row, Col, Modal } from "react-bootstrap";

import { useCoachPoolContext } from "../../../contexts/CoachPoolContext";
import { useTeamCoachPoolContext } from "../../../contexts/TeamCoachPoolContext";
import Select from "react-select";

import Tooltip from "../../ui/Tooltip";

export default function ChooseCoachPool() {
  const { dispatch, actions, state } = useCoachPoolContext();
  const {
    dispatch: dispatchTeam,
    actions: actionsTeam,
    state: stateTeam,
  } = useTeamCoachPoolContext();

  const [pool, setPool] = useState(stateTeam.team.attributes.coach_pool_id);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    actions.loadCoachPools(dispatch);
  }, []);

  const onCoachPoolChange = (value, action) => {
    setPool(value.value);
  };

  const removeCoachPool = () => {
    setLoader(true);
    actionsTeam.removeCoachPool(
      dispatchTeam,
      stateTeam.team,
      () => {
        actionsTeam.loadCoaches(dispatchTeam, stateTeam.team);
        setLoader(false);
        toastr["info"]("Custom Coach Pool was removed.");
      },
      () => {
        alert(error);
        setLoader(false);
      }
    );
  };

  const assignNewPool = () => {
    if (pool != null) {
      setLoader(true);
      actionsTeam.assignCoachPool(
        dispatchTeam,
        stateTeam.team,
        pool,
        () => {
          actionsTeam.loadCoaches(dispatchTeam, stateTeam.team);
          setLoader(false);
          toastr["info"]("Coach Pool was successfully assigned.");
        },
        () => {
          alert(error);
          setLoader(false);
        }
      );
    }
  };

  return (
    <>
      <p>Select and add the Coach Pool to the Team.</p>
      <Row>
        <Col md={8}>
          <Select
            onChange={onCoachPoolChange}
            placeholder="Select Pool"
            options={(state.coachPools || [])
              .filter((item) => !item.attributes.default)
              .map((item) => {
                return {
                  label: item.attributes.name,
                  value: item.id,
                };
              })}
          />
        </Col>
        <Col md={4}>
          <a
            data-tip={
              pool == null
                ? "Please, select a Coach Pool from the list and click the button."
                : null
            }
            onClick={assignNewPool}
            className="btn btn-green w-150"
          >
            Add To Team
          </a>
          {stateTeam.team.attributes.coach_pool_id != null && (
            <a
              data-tip="Click the button if you'd like to use the Default Pool for the Team."
              onClick={removeCoachPool}
              className="btn btn-green ml5 w-150"
            >
              Reset List
            </a>
          )}
        </Col>
      </Row>
      <Tooltip />
      <Modal className="student inmodal auto without-overflow" show={loader}>
        <Modal.Body className="text-center">
          <i className="fa fa-spinner fa-spin" style={{ fontSize: "4em" }}></i>
          <h3>Please wait ...</h3>
        </Modal.Body>
      </Modal>
    </>
  );
}
